import axios from "../../lib/axios";
import { IFilter } from "../../types/filters.types";
import checkIsLocalhost from "../../utils/checkIsLocalhost";

const baseUrl = process.env.REACT_APP_API_BASE_URL || "/";

export const getDCOrderHistoryData = (filters: IFilter): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getUnifiedOrderHistory(MViewInput: {DCDivision: ${filters.warehouseDivision}, RetailDivision: ${filters.retailDivision}, DistributionCenter: ${filters.distribution}, Warehouse: ${filters.warehouse}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}, CIC: "${filters.cic}"})
    {
      dcOrderHistory {
        poNumber
        orderQuantitySellingUnits
        orderQuantityShippingUnits
        orderQuantityVendorUnits
        status
        dcEstimatedArrivalDate
      }
      errors { errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/mview`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw,
  );
};

export const getStoreOrderHistoryData = (filters: IFilter): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getUnifiedOrderHistory(MViewInput: {DCDivision: ${filters.warehouseDivision}, RetailDivision: ${filters.retailDivision}, DistributionCenter: ${filters.distribution}, Warehouse: ${filters.warehouse}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}, CIC: "${filters.cic}"})
    {
      storeOrderHistory {
        orderNumber
        orderQuantitySellingUnits
        orderQuantityShippingUnits
        orderQuantityVendorUnits
        statusTypeCd
        orderDate
        scheduledDeliveryDate
      }
      errors { errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/mview`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw,
  );
};

export const getBuyerCommentsData = (filters: IFilter): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getUnifiedBuyerComments(MViewInput: {DCDivision: ${filters.warehouseDivision}, RetailDivision: ${filters.retailDivision}, DistributionCenter: ${filters.distribution}, Warehouse: ${filters.warehouse}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}, CIC: "${filters.cic}"})
    {
      comment1
      comment2
      comment3
      errors{ errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/mview`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw,
  );
};

export const getDCOrderHistoryTotal = (filters: IFilter): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getUnifiedOrderHistoryTotal(MViewInput: {DCDivision: ${filters.warehouseDivision}, RetailDivision: ${filters.retailDivision}, DistributionCenter: ${filters.distribution}, Warehouse: ${filters.warehouse}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}, CIC: "${filters.cic}"})
    {
      dcOrderTotalQtySellingUnits
      dcOrderTotalQtyShippingUnits
      dcOrderTotalQtyVendorUnits
      errors { errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/mview`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw,
  );
};

export const getStoreOrderHistoryTotal = (filters: IFilter): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getUnifiedOrderHistoryTotal(MViewInput: {DCDivision: ${filters.warehouseDivision}, RetailDivision: ${filters.retailDivision}, DistributionCenter: ${filters.distribution}, Warehouse: ${filters.warehouse}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}, CIC: "${filters.cic}"})
    {
      storeOrderTotalQtySellingUnits
      storeOrderTotalQtyShippingUnits
      storeOrderTotalQtyVendorUnits
      errors { errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/mview`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw,
  );
};
